export default __webpack_public_path__ + "static/media/logo.200152b0.svg";